import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=a2b76a16&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "./Terms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports